<template>
  <symbol
    :width="width"
    :height="height"
    :id="'g' + number"
    :viewBox="viewBox"
    >
    <line
      v-for="(line, i) in verticalLines"
      :key=i
      v-bind="line"
      :style="lineStyle"
    />
    <line
      v-if="hasHorizontalLine"
      v-bind="horizontalLine"
      :style="lineStyle"
    />
  </symbol>
</template>

<script>
/* eslint-disable no-mixed-operators,no-plusplus */

import {
  NUM_IN_GROUP,
  STROKE_COLOR,
  STROKE_WIDTH,
  H_PADDING,
  V_PADDING,
} from './Constants';


export default {
  name: 'TallyMarkGroup',
  data() {
    return {
      hPadding: H_PADDING,
      vPadding: V_PADDING,
      lineStyle: {
        stroke: STROKE_COLOR,
        strokeLinecap: 'round',
        strokeWidth: STROKE_WIDTH,
      },
    };
  },
  computed: {
    viewBox() {
      const { hSize, vSize } = this;
      return `0 0 ${hSize} ${vSize}`;
    },
    hSize() {
      const { width, height } = this;
      return width >= height ? width / height : 1.0;
    },
    vSize() {
      const { width, height } = this;
      return height > width ? height / width : 1.0;
    },
    verticalLines() {
      const numLines = Math.min(this.number, NUM_IN_GROUP - 1);
      const { hPadding, vPadding, hSize, vSize } = this;
      const lines = [];
      const hSpacing = (hSize - 2 * hPadding) / (NUM_IN_GROUP - 1);
      for (let i = 0; i < numLines; i++) {
        lines.push({
          x1: hPadding + (i + 0.5) * hSpacing,
          y1: vPadding,
          x2: hPadding + (i + 0.5) * hSpacing,
          y2: vSize - vPadding,
        });
      }
      return lines;
    },
    horizontalLine() {
      const { hPadding, vPadding, hSize, vSize } = this;
      return {
        x1: hPadding,
        y1: 1.5 * vPadding,
        x2: hSize - hPadding,
        y2: vSize - 1.5 * vPadding,
      };
    },
    hasHorizontalLine() {
      return this.number === NUM_IN_GROUP;
    },
  },
  props: ['number', 'width', 'height'],
};
</script>

<style scoped>
  div.vertical {

  }
</style>



// WEBPACK FOOTER //
// src/components/TallyMarkGroup.vue